import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import analytics, { setupRouterTracking } from './plugins/analytics'
import i18n, { t } from './i18n'

const app = createApp(App)

// 使用路由
app.use(router)

// 使用 Google Analytics 插件
app.use(analytics)

// 使用国际化插件
app.use(i18n)

// 设置路由追踪（自动追踪页面浏览）
setupRouterTracking(router)

// 设置页面标题
document.title = t('site.title')

app.mount('#app')
